<header class="app-header navbar" [class.fixed-top]="fixed">
  <button class="navbar-toggler" type="button" (click)="toggleSidebar()" title="Menu">
    <fa-icon [icon]="['fas', 'bars']"></fa-icon>
  </button>

  <div class="navbar-brand" [routerLink]="navbarBrandRouterLink">
    @if (navbarBrandFull) {
      <img [src]="navbarBrandFull.src" [alt]="navbarBrandFull.alt" class="navbar-brand-full">
    }
    @if (navbarBrandMinimized) {
      <img [src]="navbarBrandMinimized.src" [alt]="navbarBrandMinimized.alt" class="navbar-brand-minimized hidden min-[992px]:block">
    }
  </div>

  <ng-content select="[headerLeft]"></ng-content>

  <div class="header-center-slot">
    <ng-content select="[headerCenter]"></ng-content>
  </div>

  <ul class="nav navbar-nav ml-auto px-2">
    <ng-content></ng-content>
    @if (asideMenuToggler) {
      <li class="nav-item">
        <button class="navbar-toggler aside-menu-toggler" type="button" (click)="toggleAside()" title="Notification panel">
          <fa-icon [icon]="['fas', 'list']"></fa-icon>
        </button>
      </li>
    }
  </ul>
</header>
